module.exports = __webpack_public_path__ + "img/799.abab2ba6.png";